/**
 * Labstep
 *
 * @module components/ResourceItem/ResourceLocationModal
 * @desc Modal to view and edit resource location modal
 */

import { EntityActionEditModal } from 'labstep-web/components/Entity/Action/Edit/Modal';
import { ResourceItemResourceLocationModalContent } from 'labstep-web/components/ResourceItem/ResourceLocationModal/Content';
import { ResourceLocationLabelBasic } from 'labstep-web/components/ResourceLocation/Label/Basic';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type React from 'react';
import type { IResourceItemResourceLocationModalProps } from './types';

export const ResourceItemResourceLocationModal: React.FC<
  IResourceItemResourceLocationModalProps
> = ({ resourceItem, hideMap, modalProps }) => {
  const fullScreen = !!resourceItem.resource_location && !hideMap;
  return (
    <EntityActionEditModal
      entity={resourceItem}
      header={null}
      showDone={!fullScreen}
      closeIcon={fullScreen}
      renderIfNoEditPermissions
      viewComponent={
        (({ toggleModal, canEdit }) => (
          <div onClick={toggleModal} style={{ cursor: 'pointer' }}>
            {resourceItem.resource_location ? (
              <ResourceLocationLabelBasic
                withIcon
                withPopup
                resourceLocation={resourceItem.resource_location}
              />
            ) : (
              <ActionComponent
                type="text"
                text={canEdit ? 'Specify location' : 'No location'}
                elementProps={{ placeholder: true }}
              />
            )}
          </div>
        )) as any
      }
      content={
        <ResourceItemResourceLocationModalContent
          resourceItem={resourceItem}
          hideMap={hideMap}
        />
      }
      size={fullScreen ? 'fullscreen' : 'small'}
      usePortal={false}
      {...modalProps}
    />
  );
};
